export const API_OPTIONS = [
  ['coverages', 'Coverages'],
  ['claim-statuses', 'Claim Statuses'],
  ['patient-cost', 'Patient Cost Estimator'],
  ['payment-accuracy', 'Payment Accuracy'],
  ['all', 'All']
] as const;

export const ROLE_OPTIONS = ['Developer', 'Product', 'Architect', 'Admin', 'Other'] as const;

export const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'mail.com',
  'protonmail.com'
]);

export const ACCORDION_CONTENT = {
  'Who Qualifies': [
    'Innovative organizations or teams ready to experiment with the API, validate real-world use cases, and collaborate closely by offering early insights that influence the product direction.',
    'Existing customers with valid portal access and an active contract.'
  ],
  'What Do I Get': [
    'Early Access to the API',
    'Direct Influence on Product Direction',
    'Detailed API Documentation & Resources',
    'Opportunity to Validate Real Use Cases',
    'Participation in Exclusive Feedback Cycles'
  ],
  'Whats Next After Submit': [
    'Submission Review & Eligibility Check',
    'Confirmation & Onboarding Instructions',
    'Access Provisioning',
    'Start Exploring',
    'Participate in Feedback Cycles'
  ]
};

export const WHY_JOIN_ITEMS = [
  ['Try New APIs First', 'Be the first to access our API network'],
  ['Give Feedback', 'Influence our roadmap to benefit your long-term goals'],
  ['Limited Seats Available', 'Get exclusive access']
] as const;
